module.exports = __webpack_public_path__ + "img/charge.2a4ddf94.svg";